import React,{useState} from 'react';
import { ClickAwayListener } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import ChallengeCard from 'components_newui/challenge_card/View';
import FileUploader from 'components_newui/new_ui_file_uploader/View'
// import { ReactFormGenerator } from 'react-form-builder2';
import { ReactFormGenerator } from 'components_newui/formBuilder/react-form-builder-innovate/src/index';
import { ButtonLink } from 'components'
import Button from 'components_newui/button/View'
import TextEditor from 'components/text_editor/View'
import IdeaAvatar from './idea_avatar/View'
import { htmlToPlainText } from 'services/RequestUtils';
import defaultPhoto from 'img/default-photo.png'
import i18n from 'support/i18n'
import SendJoinSection from '../../../new_idea_detail/components/send_join_section/View'
import PendingInvitations from '../../../new_idea_detail/components/send_join_section/components/pendings_invitations/View'

import AutoSuggestion from 'components/autosuggestion/View'
import SuggestionSelected from 'components/suggestion_selected/View'



const useStyles = makeStyles((theme) => ({
  // root: {
  //     width: '100%',
  // },
  alignTeams:{
    display: 'flex', justifyContent: 'space-between', gap:'8px'
  },
  
  editorButtons: {
    display: 'flex', justifyContent: 'space-between', marginTop: '20px'
  },
  joinTheTeamContainer: {
    padding: '1rem 0',
  },
  root: {
    padding: theme.spacing(3, 0, 3, 0),
    borderTop: '1px solid #b3b3b3',
  },
  titleSection: {
    // display: 'flex',
    // alignItems: 'center',
    fontWeight:400,
        fontFamily: theme.fontFamily.fontFamilyRegular, 
        fontSize: '32px',
        marginTop: '16px',
        marginBottom: '16px',
    '& > span': {
      fontSize: '32px',
      marginRight: theme.spacing(1),
    },
  },
  joinButton:{
  fontFamily: theme.fontFamily.fontFamilyRegular,
  fontSize: '12px',
  color: '#FFFFFF',
  background: '#333333',
  width: '120px',
  borderRadius: '20px',
    '&:hover': {
      background: '#333333b5',
    },
  },
  rows:{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  idea_preview: {
    zIndex: 10,
    marginTop: '150px',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: 'auto',
  },
  faded_out: {
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 100,
    width: '100%',
    height: '100%',
    top: 0,
    left:0,
  },
  containerWrp: {
  backgroundColor: '#FFFFFF',
  borderRadius: '6px',
  width: '980px',
  padding: '32px 48px',
  fontFamily: 'VodafoneRg-Regular',
  color: '#333333'
  },
title:{
    fontSize: '32px'
},
subtitle: {
    fontSize: '18px',
    margin: '16px 0',
},

pendingUsersContainer: {
  display: 'flex',
  flexWrap: 'wrap',
  marginTop:'24px',
  alignItems:'start',
  '& img': {
    '-webkit-filter': 'grayscale(1)',
    filter: 'grayscale(1)',
  },
},

}));


const isEditorEmpty = (html) => {
  if (!html) return true;
  const text = html.replace(/<[^>]*>/g, '').trim();
  return text.length === 0;
};



const IdeaContent = (props) => {
  const classes = useStyles()
  const  { isOrganizer,isAdmin,isOwner,handleTeamMemberOpenPopup,
    additionalInfo,challenge, documents, description, formData, 
    formAnswers, csrfToken, getInnovateIdeaTeamIsLoading,getIdeaTeamData,onTeamUserClick,
    innovateChallengeTagIdeaCount,onTeamUserRemoveClick, 
    canSendIdeaTeamInvitations,
    suggestions,
    pendingInvitationsUsers,
    idea_id,
    isAlreadyInvited,
    onRequestJoinIdeaTeam,
    handleDeleteUserFromTeam,
    navigateToUserProfile,
    onSearchSuggestions,
    handleSendInvitation,
    isSearchingForUser,
    ownerEmail,
    title,
    team,
    inviteTeam,
    inputHelpText,
    inputLabel
  } = props


  const [requestAccessToTeam,setRequestAccessToTeam] = useState('')
  const [editorError, setEditorError] = useState('');

  const [InviteeFormPopup,setInviteeFormPopup] = useState(false)
  const [showJoinTeamDialog,setShowJoinTeamDialog] = useState(false)
  const [selectedSuggestion,setSelectedSuggestion] = useState({})

  const handleSendRequest =(requestText) =>{
    onRequestJoinIdeaTeam(idea_id, requestText)
    setShowJoinTeamDialog(false)
  }


  const togglepopup = ()=>{
      setShowJoinTeamDialog(!showJoinTeamDialog)
  }
  
  const toggleInvitePopup = ()=>{
    setInviteeFormPopup(!InviteeFormPopup)
   }
   const InviteeFormPopupCancel = ()=>{
    setInviteeFormPopup(false)
    setSelectedSuggestion({})
 }


return (
  <>
    <div>
      <h3>Tagged Challenge</h3>
      {/* {console.log("challenge tag :", challenge)} */}
      <ChallengeCard challenge={challenge} tagging={false} tagged={false} urlID={challenge?.id} hideProposedName innovateChallengeTagIdeaCount={innovateChallengeTagIdeaCount} />
    </div>
    {documents?.length > 0 && (
      <div>
        <p><strong>Uploaded files</strong></p>
        {/* Add FileUploaderFn here if needed */}
        <FileUploader
          documentfiles={documents}
          csrfToken={csrfToken}
          previewInputHideIdea
        />
      </div>
    )}
    <div>
      <h3>Description</h3>
      <p>{description || 'Not Available'}</p>
    </div>
   

    <div>
      <h3>Idea Content</h3>
      <ReactFormGenerator
        data={Array.isArray(formData) ? formData : []}
        answer_data={Array.isArray(formAnswers) ? formAnswers : []}
        hide_actions
        read_only
      />
    </div>

    { additionalInfo && (
       <div>
        <h3>Additional Information</h3>
        <p>{htmlToPlainText(additionalInfo) || 'Not Available'}</p>
      </div>
      )}


    {getIdeaTeamData?.length > 0 &&
      <div className={classes.ideaTeamSection}>
        <div className={classes.alignTeams}>
          <h2 className={classes.ideaTeamSectionTitle}>Idea team</h2>
         
         <div className='rightblock'>
            {(isAdmin || isOrganizer || isOwner) && <Button type="button" className={classes.AddMemberBtn} onClick={handleTeamMemberOpenPopup} text="Add member" ></Button>} 

      
            
            { !(isAdmin || isOrganizer || isOwner) &&  (
              <Button
                className={classes.joinButton}
                color="primary"
                onClick={togglepopup}
                text={i18n.t('IDEA.JOIN_THIS_TEAM')}
              />
            )}

          </div>


        </div>

        <div className={classes.alignMember}>{
          getIdeaTeamData?.map(userTeam => {
            // console.log("userTeam", userTeam)
            return (
              <ButtonLink
                onLinkClick={() => onTeamUserClick(userTeam?.email)}
                key={userTeam?.email}
                className
              >
                <IdeaAvatar
                  name={userTeam?.name || "Unknown"}
                  photoSrc={userTeam?.photo || defaultPhoto}
                // isAdmin={highlightedUserEmail === userTeam.email}
                  hasDeleteButton={isAdmin || isOrganizer || isOwner}
                  onDeleteButtonClick={() => onTeamUserRemoveClick(userTeam.email)}
                />
              </ButtonLink>
            )
          })
        }</div>
      </div>
    }




{/* join and send text and hide after okay response */}

      {
        showJoinTeamDialog &&
        <div>
        {
        isAlreadyInvited ?  (
          <div className={classes.faded_out} >
            <div className={classes.idea_preview}>
              <ClickAwayListener onClickAway={() => setShowJoinTeamDialog(false)}>
                <div className={classes.containerWrp}>
                    <h3 className={classes.title}>Your join team request is already sent to Idea Ideator. </h3>
                    <div className={classes.editorButtons}>
                      <Button
                        id="cancel-button"
                        onClick={() =>  setShowJoinTeamDialog(false)}
                        text={i18n.t('IDEA.CANCEL')}
                      ></Button>
                    </div>
                </div>
              </ClickAwayListener>
            </div>
        </div>

        ) : (
          <div className={classes.faded_out} >
            <div className={classes.idea_preview}>
              <ClickAwayListener onClickAway={() => setShowJoinTeamDialog(false)}>
                <div className={classes.containerWrp}>
                  <div className={classes.title}>
                      Join the idea team
                  </div>
                  <div className={classes.subtitle}>
                      Explain why you want to be part of the idea team.
                  </div>

                  <TextEditor
                    onTextChange={text => setRequestAccessToTeam(text)}
                    value={requestAccessToTeam}
                    // onTextChange={(text) => {
                    //   setRequestAccessToTeam(text);
                    //   if (!isEditorEmpty(text)) {
                    //     setEditorError('');
                    //   }
                    // }}
                    showDescription={false}
                  />

                  {editorError && (
                    <div className={classes.errorText}>
                      {editorError}
                    </div>
                  )}

                  <div className={classes.editorButtons}>
                    <Button
                      id="cancel-button"
                      onClick={() =>  setShowJoinTeamDialog(false)}
                      text={i18n.t('IDEA.CANCEL')}
                    ></Button>
                    
                    <Button
                      id="send-invitation-button"
                      onClick={() => handleSendRequest(requestAccessToTeam)}
                      text={i18n.t('IDEA.SEND_REQUEST')}
                    >
                    </Button>

                  </div>
                </div>
        


              </ClickAwayListener>
            </div>
          </div>
        )} 
        </div>
      }


  </>
);
}

export default IdeaContent;